module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "website-layout-css-grid.30de2e86.png" + "?" + Date.now();